import React from 'react';
import ReactDOM from 'react-dom';

import App from './app';

import './styles/main.css';

var mountNode = document.getElementById('app');

ReactDOM.render(<App />, mountNode);
